import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { toast, Toaster } from 'sonner';
const BACKEND = process.env.REACT_APP_BACKEND_URL;
const PLATFORMS = [
  { key: 'instagram', label: 'Instagram' },
  { key: 'youtube', label: 'YouTube' },
  { key: 'threads', label: 'Threads' },
  { key: 'facebook', label: 'Facebook' },
  { key: 'whatsapp', label: 'WhatsApp' },
  { key: 'website', label: 'Website & Portfolio' },
];

export default function PublicConsent() {
  const { project_id } = useParams();
  const [f, setF] = useState({ client_name: '', permissions: {} });
  const [signed, setSigned] = useState(false);
  const [done, setDone] = useState(false);
  const set = (p, v) => setF({ ...f, permissions: { ...f.permissions, [p]: v } });
  const submit = async () => {
    if (!f.client_name) { toast.error('Please enter your name'); return; }
    if (!signed) { toast.error('Please tick to sign'); return; }
    await axios.post(`${BACKEND}/api/public/consent/${project_id}`, f);
    setDone(true);
  };
  if (done) return <div className="min-h-screen flex items-center justify-center px-6"><div className="text-center"><div className="serif text-[26px]">Signed. Thank you.</div></div></div>;
  return (
    <div className="min-h-screen py-8 px-4" style={{background:'var(--cream)'}}>
      <Toaster position="top-center" richColors/>
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-8">
          <div className="serif text-[32px]">Photograph Consent</div>
          <div className="eyebrow mt-2">Rishika Sharma</div>
          <div className="gold-rule my-4 mx-auto" style={{width:60}}/>
        </div>
        <div className="card-cream p-6 mb-4">
          <div className="text-sm mb-4">I grant permission for photographs taken during my appointment with Rishika Sharma to be used on the platforms I tick below. Each platform is a separate choice.</div>
          <div className="space-y-2">
            {PLATFORMS.map(p => (
              <div key={p.key} className="flex items-center justify-between py-2 border-b hairline">
                <div className="text-sm">{p.label}</div>
                <div className="flex gap-2">
                  <button onClick={() => set(p.key, true)} className="px-3 py-1 text-xs rounded-full" style={{background: f.permissions?.[p.key]===true?'var(--ok)':'transparent', color: f.permissions?.[p.key]===true?'#fff':'var(--charcoal)', border:'1px solid var(--line)'}} data-testid={`consent-${p.key}-yes`}>Yes</button>
                  <button onClick={() => set(p.key, false)} className="px-3 py-1 text-xs rounded-full" style={{background: f.permissions?.[p.key]===false?'var(--overdue)':'transparent', color: f.permissions?.[p.key]===false?'#fff':'var(--charcoal)', border:'1px solid var(--line)'}} data-testid={`consent-${p.key}-no`}>No</button>
                </div>
              </div>
            ))}
          </div>
          <div className="text-xs text-[var(--muted)] mt-4 italic">This consent is permanent once signed. There is no revocation clause.</div>
        </div>
        <div className="card-cream p-6">
          <label className="eyebrow">Your full name (signature)</label>
          <input value={f.client_name} onChange={e => setF({...f, client_name: e.target.value})} data-testid="consent-name"/>
          <label className="flex items-center gap-2 text-sm mt-3"><input type="checkbox" style={{width:'auto'}} checked={signed} onChange={e => setSigned(e.target.checked)} data-testid="consent-sign"/> I sign this consent on {new Date().toLocaleDateString('en-GB', { day:'2-digit', month:'short', year:'numeric' })}</label>
          <button className="btn-gold w-full mt-4" onClick={submit} data-testid="consent-submit">Sign & Submit</button>
        </div>
      </div>
    </div>
  );
}
